/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import SuccessIcon from '@atlaskit/icon/utility/check-circle';
import ErrorIcon from '@atlaskit/icon/utility/error';
import { Box, xcss } from '@atlaskit/primitives';
var messageStyles = xcss({
  display: 'flex',
  justifyContent: 'baseline',
  gap: 'space.050',
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  marginBlockStart: 'space.050'
});
var messageAppearanceStyles = {
  default: xcss({
    color: 'color.text.subtlest'
  }),
  error: xcss({
    color: 'color.text.danger'
  }),
  valid: xcss({
    color: 'color.text.success'
  })
};
var iconWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginInlineStart: "var(--ds-space-025, 2px)",
  marginInlineEnd: "var(--ds-space-025, 2px)"
});
var IconWrapper = function IconWrapper(_ref) {
  var children = _ref.children;
  return jsx("span", {
    css: iconWrapperStyles
  }, children);
};
var messageIcons = {
  error: jsx(ErrorIcon, {
    color: "var(--ds-text-danger, #AE2A19)",
    label: "error"
  }),
  valid: jsx(SuccessIcon, {
    color: "var(--ds-text-success, #216E4E)",
    label: "success"
  })
};
export var Message = function Message(_ref2) {
  var children = _ref2.children,
    _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance,
    id = _ref2.id,
    testId = _ref2.testId;
  var icon = messageIcons[appearance];

  /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */
  var content = typeof children === 'string' ? children : jsx("span", null, children);
  return jsx(Box, {
    xcss: [messageStyles, messageAppearanceStyles[appearance]],
    testId: testId,
    id: id
  }, icon && jsx(IconWrapper, null, icon), content);
};